import * as $ from 'jquery';
import ServiceREST from "../Core/ServiceREST";
import Map from 'ol/Map';
import Overlay from 'ol/Overlay.js';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {Style, Icon, Text, Fill} from 'ol/style.js';
import {fromLonLat} from 'ol/proj.js';
import {defaults as defaultControls, OverviewMap} from 'ol/control.js';
import {defaults as defaultInteractions} from 'ol/interaction.js';
import {onClick} from "Core/Events";

export default class OSMap extends ServiceREST {
    public map;
    public rest;

    public popup;
    readonly Selector: any;

    constructor() {
        super();
        super.rest = this.rest;
        this.map = this.map;

        this.Selector = {
            POPUP: {
                CONTAINER: '#popup_map',
                CLOSE_BTN: '#popup-closer',
                CONTENT: '#popup-content',
            }
        }

        this.popup = this.setOverlay();
        this.closePopup = this.closePopup.bind(this);
    }

    /**
     * Metoda inicjalizująca OpenStreetMaps. Zeby wszystko dobrze dzialalo nalezy wpierw zainicjalizowac
     * klase poprzez stworzenie nowej zmiennej i przypisanie jej instancji klasy, a pozniej uzycie tej metody
     * @example
     * const Map = new OSMap();
     * Map.init(id, lon, lat, 18);
     *
     * @param {string} id Id elementu
     * @param {number} lon Długość geograficzna
     * @param {number} lat Szerokość geograficzna
     * @param {number} zoom Stopień przyblizenia na start.
     *
     * @return map - czyli mapa z określonymi parametrami
     */
    public init(id: string, lon: number, lat: number, zoom: number) {
        this.map = new Map({
            interactions: defaultInteractions({
                doubleClickZoom: true,
                dragAndDrop: false,
                keyboardPan: false,
                keyboardZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: false
            }),
            controls: defaultControls().extend([
                new OverviewMap()
            ]),
            layers: [
                new TileLayer({
                    source: new OSM()
                })
            ],
            target: id,
            view: new View({
                center: fromLonLat([lon, lat]),
                zoom: zoom
            })
        });
        return this.map;
    }

    /**
     * Metoda dodaje znacznik na mapie i zmienia pozycję mapy tak by znacznik ten
     * znajdował się na środku
     *
     * @param {string} markerImageSrc Ściezka do obrazka tego znacznika. Moze to byc zewnetrzny URL albo sciezka
     * do konkretnego pliku projektu w folderze public/build/assets/images/
     */
    public addMarker(markerImageSrc: string) {
        const center = this.map.getView().getCenter();
        const feature = new Feature(new Point(center));
        const pinLayer = new VectorLayer({
            source: new VectorSource({features: [feature]}),
            style: new Style({
                image: new Icon({
                    src: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
                    scale: 0.1
                })
            })
        });

        this.map.addLayer(pinLayer);
    };


    public addPoint(lng, lat, description) {
        let feature = new Feature({
            geometry: new Point(fromLonLat([parseFloat(lng), parseFloat(lat)]))
        })

        feature.set('description', description)

        var vectorLayer = new VectorLayer({
            source: new VectorSource({features: [feature]}),
            style: new Style({
                image: new Icon({
                    src: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
                    scale: 0.1
                })
            })
        });
        this.map.addLayer(vectorLayer);
    }

    public initClickPopover() {
        let $this = this;
        this.map.addOverlay($this.popup);
        this.map.on('click', function (evt) {
            let feature = this.forEachFeatureAtPixel(evt.pixel,
                function (feature) {
                    return feature;
                });
            if (feature) {
                $this.popup.setPosition(feature.getGeometry().getCoordinates());
                $($this.Selector.POPUP.CONTENT).html(feature.get('description'));
            } else {
                $this.popup.setPosition(undefined);
            }
        });
    }

    private setOverlay() {
        return new Overlay({
            element: $(this.Selector.POPUP.CONTAINER)[0]
        });
    }

    public closePopup(event) {
        event.preventDefault();
        this.popup.setPosition(undefined);
        return false;
    }

    public onLoad() {
        onClick(this.Selector.POPUP.CLOSE_BTN, this.closePopup);
    }
}
import * as $ from 'jquery';
import ServiceREST from "../Core/ServiceREST";
import Map from 'ol/Map';
import Overlay from 'ol/Overlay.js';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {Style, Icon, Text, Fill} from 'ol/style.js';
import {fromLonLat} from 'ol/proj.js';
import {defaults as defaultControls, OverviewMap} from 'ol/control.js';
import {defaults as defaultInteractions} from 'ol/interaction.js';
import {onClick} from "Core/Events";

export default class OSMap extends ServiceREST {
    public map;
    public rest;

    public popup;
    readonly Selector: any;

    constructor() {
        super();
        super.rest = this.rest;
        this.map = this.map;

        this.Selector = {
            POPUP: {
                CONTAINER: '#popup_map',
                CLOSE_BTN: '#popup-closer',
                CONTENT: '#popup-content',
            }
        }

        this.popup = this.setOverlay();
        this.closePopup = this.closePopup.bind(this);
    }

    /**
     * Metoda inicjalizująca OpenStreetMaps. Zeby wszystko dobrze dzialalo nalezy wpierw zainicjalizowac
     * klase poprzez stworzenie nowej zmiennej i przypisanie jej instancji klasy, a pozniej uzycie tej metody
     * @example
     * const Map = new OSMap();
     * Map.init(id, lon, lat, 18);
     *
     * @param {string} id Id elementu
     * @param {number} lon Długość geograficzna
     * @param {number} lat Szerokość geograficzna
     * @param {number} zoom Stopień przyblizenia na start.
     *
     * @return map - czyli mapa z określonymi parametrami
     */
    public init(id: string, lon: number, lat: number, zoom: number) {
        this.map = new Map({
            interactions: defaultInteractions({
                doubleClickZoom: true,
                dragAndDrop: false,
                keyboardPan: false,
                keyboardZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: false
            }),
            controls: defaultControls().extend([
                new OverviewMap()
            ]),
            layers: [
                new TileLayer({
                    source: new OSM()
                })
            ],
            target: id,
            view: new View({
                center: fromLonLat([lon, lat]),
                zoom: zoom
            })
        });
        return this.map;
    }

    /**
     * Metoda dodaje znacznik na mapie i zmienia pozycję mapy tak by znacznik ten
     * znajdował się na środku
     *
     * @param {string} markerImageSrc Ściezka do obrazka tego znacznika. Moze to byc zewnetrzny URL albo sciezka
     * do konkretnego pliku projektu w folderze public/build/assets/images/
     */
    public addMarker(markerImageSrc: string) {
        const center = this.map.getView().getCenter();
        const feature = new Feature(new Point(center));
        const pinLayer = new VectorLayer({
            source: new VectorSource({features: [feature]}),
            style: new Style({
                image: new Icon({
                    src: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
                    scale: 0.1
                })
            })
        });

        this.map.addLayer(pinLayer);
    };


    public addPoint(lng, lat, description) {
        let feature = new Feature({
            geometry: new Point(fromLonLat([parseFloat(lng), parseFloat(lat)]))
        })

        feature.set('description', description)

        var vectorLayer = new VectorLayer({
            source: new VectorSource({features: [feature]}),
            style: new Style({
                image: new Icon({
                    src: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
                    scale: 0.1
                })
            })
        });
        this.map.addLayer(vectorLayer);
    }

    public initClickPopover() {
        let $this = this;
        this.map.addOverlay($this.popup);
        this.map.on('click', function (evt) {
            let feature = this.forEachFeatureAtPixel(evt.pixel,
                function (feature) {
                    return feature;
                });
            if (feature) {
                $this.popup.setPosition(feature.getGeometry().getCoordinates());
                $($this.Selector.POPUP.CONTENT).html(feature.get('description'));
            } else {
                $this.popup.setPosition(undefined);
            }
        });
    }

    private setOverlay() {
        return new Overlay({
            element: $(this.Selector.POPUP.CONTAINER)[0]
        });
    }

    public closePopup(event) {
        event.preventDefault();
        this.popup.setPosition(undefined);
        return false;
    }

    public onLoad() {
        onClick(this.Selector.POPUP.CLOSE_BTN, this.closePopup);
    }
}
